import { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import useLayersChange from "../../../../../hooks/useLayersChange";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { getVisibleFilters } from "../../../../../utils/helper";
import { StyledFiltersCount } from "../Sidebar-styled";

const FiltersCount = ({ expanded }) => {
  const { config } = useContext(ConfigContext);
  const filters = useSelector((state) => state.filters);
  const activeModule = useSelector((state) => state.activeModule);
  const { layerCount } = useLayersChange(config);

  const activeFiltersCount = useMemo(() => {
    const activeFilterFieldNames = Object.values(
      getVisibleFilters(config, activeModule, filters)
    ).map((filter) => filter.field.name);

    let count = 0;
    activeFilterFieldNames.forEach((field) => {
      const filter = filters[activeModule][field];
      if (Array.isArray(filter) && filter.length > 0) {
        count++;
      }
    });

    return count;
  }, [config, layerCount, filters, activeModule]);

  if (activeFiltersCount === 0) {
    return null; // Return null if there are no active filters
  }

  return (
    <StyledFiltersCount expanded={expanded}>
      {activeFiltersCount}
    </StyledFiltersCount>
  );
};

export default FiltersCount;
